import { motion } from "framer-motion";
import clsx from "clsx";
import { ReactNode } from "react";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.3,
      staggerChildren: 0.1,
      delayChildren: 0.1,
    },
  },
};

type TabPanelProps = {
  children: ReactNode;
  className?: string;
};

export const TabPanel = ({ children, className }: TabPanelProps) => {
  return (
    <div className="h-full overflow-auto">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className={clsx("space-y-4 p-4", className)}
      >
        {children}
      </motion.div>
    </div>
  );
};
